import { BLOG_POSTS } from '@/constants/blogPosts'
import { CORE_PAGES } from '@/data/corePages'
import { CORE_SUB_PAGES } from '@/data/coreSubPages'

function normalizePath(path) {
	if (!path || path === '/') return '/'
	return path.endsWith('/') ? path : `${path}/`
}

/**
 * @returns {{ label: string, to: string | null }[]}
 */
const STATIC_PAGE_CRUMBS = {
	'/download/': 'Download',
	'/download-apk-page/': 'Download',
	'/old-versions/': 'Old Versions',
	'/for-pc/': 'For PC',
	'/for-iphone-ios/': 'For iPhone / iOS',
	'/faq/': 'FAQ',
	'/about/': 'About',
	'/contact/': 'Contact',
	'/privacy-policy/': 'Privacy Policy',
	'/terms/': 'Terms of Use',
	'/terms-of-service/': 'Terms of Use',
	'/disclaimer/': 'Disclaimer',
	'/dmca/': 'DMCA',
}

export function buildBreadcrumbs(path) {
	const normalized = normalizePath(path)
	const crumbs = [{ label: 'Home', to: '/' }]

	if (STATIC_PAGE_CRUMBS[normalized]) {
		crumbs.push({ label: STATIC_PAGE_CRUMBS[normalized], to: null })
		return crumbs
	}

	const hubPage = Object.values(CORE_PAGES).find((p) => p.path === normalized)
	if (hubPage) {
		crumbs.push({ label: hubPage.h1, to: null })
		return crumbs
	}

	const subPage = Object.values(CORE_SUB_PAGES).find((p) => p.path === normalized)
	if (subPage) {
		if (subPage.parent) {
			crumbs.push({ label: subPage.parent.label, to: subPage.parent.href })
		}
		crumbs.push({ label: subPage.h1, to: null })
		return crumbs
	}

	if (normalized === '/blog/') {
		crumbs.push({ label: 'Blog', to: null })
		return crumbs
	}

	const post = Object.values(BLOG_POSTS).find((p) => `/${p.slug}/` === normalized)
	if (post) {
		crumbs.push({ label: 'Blog', to: '/blog/' })
		crumbs.push({ label: post.h1 || post.title, to: null })
		return crumbs
	}

	return crumbs
}
